  // Define the two SETI products we care about (upper-cased for safe compare)
  export const SETI_PRODUCTS = ["SETI-DESKTOP", "SETI-BROWSER"];